import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
    if (consent === 'accepted') {
      enableAnalytics();
    }
  }, []);

  const enableAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
      });
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    enableAnalytics();
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
      });
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] animate-slide-up"
    >
      <div className="bg-[#1E3A4A] border-t border-[#2a5060] shadow-2xl">
        <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1 text-white/90 text-sm font-body leading-relaxed">
            <p>
              {language === 'en'
                ? 'We use cookies to improve your experience and analyze site traffic. By clicking "Accept", you consent to the use of cookies in accordance with our privacy policy.'
                : 'Utilizamos cookies para melhorar a sua experiência e analisar o tráfego do site. Ao clicar em "Aceitar", consente a utilização de cookies de acordo com a nossa política de privacidade.'}
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <button
              data-testid="cookie-reject-btn"
              onClick={handleReject}
              className="px-5 py-2 text-sm font-body text-white/70 hover:text-white border border-white/20 hover:border-white/40 rounded transition-colors"
            >
              {language === 'en' ? 'Reject' : 'Rejeitar'}
            </button>
            <button
              data-testid="cookie-accept-btn"
              onClick={handleAccept}
              className="px-5 py-2 text-sm font-body text-[#1E3A4A] bg-[#C5A572] hover:bg-[#b8964e] rounded font-medium transition-colors"
            >
              {language === 'en' ? 'Accept' : 'Aceitar'}
            </button>
          </div>
          <button
            onClick={handleReject}
            className="absolute top-3 right-3 sm:static text-white/40 hover:text-white transition-colors"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
